module.exports = __webpack_public_path__ + "img/17312110.b20df4dd.png";